import React from "react";
import plantbrain from "../../assets/plant.png";
import loginIAC from "../../assets/loginIAC.png";
import watermark from "../../assets/watermark.png";
import { useAuthContext } from "../../context/AuthProvider";
import { Box, Paper } from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import LogoutIcon from "@mui/icons-material/Logout";
import { useRef } from "react";
import ButtonTag from "./ButtonTag";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

const mainDivStyle = {
  width: "100%",
  height: "100vh",
  backgroundColor: "#F8F8F8",
};
const thirdDivStyle = {
  width: "100%",
  padding: "20px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  position: "fixed",
};
const pTagStyle = {
  display: "flex",
  alignItems: "center",
  gap: "5px",
};
const paperStyle = {
  position: "absolute",
  top: 60,
  right: 20,
  width: "150px",
  display: "flex",
  flexDirection: "column",
  zIndex: 999,
  backgroundColor: "white",
  margin: "auto",
  padding: "4px 12px",
  justifyContent: "space-between",
  boxShadow: "0px 3px 6px #0000001F",
};
const boxStyle = {
  fontSize: "15px",
  p: 1,
  "&:hover": { backgroundColor: "rgba(253, 87, 7, 0.1)" },
  cursor: "pointer",
  color: "#404040",
};
const iconStyle2 = {
  mb: -0.5,
  width: "20px",
  height: "20px",
  color: "#404040",
};
const divButtonStyle = {
  width: "175px",
  height: "40px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "white",
  boxShadow: "0px 3px 6px #0000001F",
  borderRadius: "10px",
  fontWeight: 500,
  cursor: "pointer",
};
const absoluteDivStyle = {
  position: "absolute",
  fontSize: "9px",
  backgroundColor: "#9F9F9F",
  color: "white",
  padding: "2px",
  borderTopRightRadius: "10px",
  right: 0,
  top: 0,
};

function Refinary() {
  const { logout, authState, setAuthState } = useAuthContext();
  const [selectedRefinary, setSelectedRefinary] = useState(
    authState.selectedRefinary
  );
  const navigate = useNavigate();
  const paperRef = useRef(null);
  const [isDropdownVisible, setDropdownVisible] = useState(false);
  const handleBoxClick = () => {
    setDropdownVisible(!isDropdownVisible);
  };
  const handleLogout = () => {
    logout();
  };
  const handleClick = (refineryName) => () => {
    setSelectedRefinary(refineryName);
  };
  const onDefault = () => {};
  const onGo = () => {
    if (selectedRefinary) {
      setAuthState({
        ...authState,
        selectedRefinary: selectedRefinary,
      });
      navigate("/");
    }
  };
  return (
    <div style={mainDivStyle}>
      <div style={thirdDivStyle}>
        <div style={{ display: "flex", alignItems: "center", gap: "18px" }}>
          <img src={watermark} alt="header" width="25px" height="25px" />
          <img src={plantbrain} alt="header" width="150px" height="25px" />
        </div>
        <div style={{ ...pTagStyle, gap: "15px" }}>
          <img src={loginIAC} alt="header" width="145px" height="25px" />
          <Box
            sx={{
              "&:hover": { color: "#FD5707" },
              cursor: "pointer",
              color: "#404040",
            }}
            onClick={handleBoxClick}
          >
            <AccountCircleIcon sx={{ fontSize: "30px" }} />
            <KeyboardArrowDownIcon
              sx={{ fontSize: "25px", ml: "-1px", mb: "2px" }}
            />
          </Box>
        </div>
        {isDropdownVisible && (
          <Paper ref={paperRef} sx={paperStyle}>
            <Box sx={boxStyle} onClick={handleLogout}>
              <LogoutIcon sx={iconStyle2} /> Sign Out
            </Box>
          </Paper>
        )}
      </div>
      <div
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: "40px",
        }}
      >
        <p style={{ fontWeight: 600, color: "#848484" }}>
          Please select a plant to continue
        </p>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "20px",
          }}
        >
          <div style={{ display: "flex", gap: "20px" }}>
            <Paper
              sx={{
                ...divButtonStyle,
                borderColor:
                  selectedRefinary === "Cottondale" ? "#0077B6" : "transparent",
                borderWidth: "2px",
                borderStyle: "solid",
                position: "relative",
                "&:hover": {
                  borderColor:
                    selectedRefinary === "Cottondale" ? "#0077B6" : "#FD5707",
                },
              }}
              onClick={handleClick("Cottondale")}
            >
              <div style={absoluteDivStyle}>Default</div>
              Cottondale
            </Paper>
            <Paper
              sx={{
                ...divButtonStyle,
                borderColor:
                  selectedRefinary === "Port Huron" ? "#0077B6" : "transparent",
                borderWidth: "2px",
                borderStyle: "solid",
                "&:hover": {
                  borderColor:
                    selectedRefinary === "Port Huron" ? "#0077B6" : "#FD5707",
                },
              }}
              // onClick={handleClick("Port Huron")}
            >
              Port Huron
            </Paper>
            <Paper
              sx={{
                ...divButtonStyle,
                borderColor:
                  selectedRefinary === "Plant 3" ? "#0077B6" : "transparent",
                borderWidth: "2px",
                borderStyle: "solid",
                "&:hover": {
                  borderColor:
                    selectedRefinary === "Plant 3" ? "#0077B6" : "#FD5707",
                },
              }}
              // onClick={handleClick("Plant 3")}
            >
              Plant 3
            </Paper>
          </div>
          <div style={{ display: "flex", gap: "20px" }}>
            <Paper
              sx={{
                ...divButtonStyle,
                borderColor:
                  selectedRefinary === "Plant 4" ? "#0077B6" : "transparent",
                borderWidth: "2px",
                borderStyle: "solid",
                "&:hover": {
                  borderColor:
                    selectedRefinary === "Plant 4" ? "#0077B6" : "#FD5707",
                },
              }}
              // onClick={handleClick("Plant 4")}
            >
              Plant 4
            </Paper>
            <Paper
              sx={{
                ...divButtonStyle,
                borderColor:
                  selectedRefinary === "Plant 5" ? "#0077B6" : "transparent",
                borderWidth: "2px",
                borderStyle: "solid",
                "&:hover": {
                  borderColor:
                    selectedRefinary === "Plant 5" ? "#0077B6" : "#FD5707",
                },
              }}
              // onClick={handleClick("Plant 5")}
            >
              Plant 5
            </Paper>
          </div>
        </div>
        <div style={{ display: "flex", gap: "20px" }}>
          <ButtonTag
            name="Mark as default"
            onClick={onDefault}
            backgroundcolor="#9F9F9F"
          />
          <ButtonTag name="Go" onClick={onGo} backgroundcolor="#34A853" />
        </div>
      </div>
    </div>
  );
}

export default Refinary;
